// extracted by css-extract-rspack-plugin
export default {"ItemIcon":"RefItem-module__ItemIcon__Y852RPh"};